// extracted by mini-css-extract-plugin
module.exports = {"tagGroup":"tips_tagGroup__HZIxW","tips1":"tips_tips1__THEqW","tips2":"tips_tips2__6SU_K","placeHolder":"tips_placeHolder__TqZwK"};